import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";

import Tooltip from "@material-ui/core/Tooltip";

import images from "../../assets/img/images";

const styles = {
  tooltip: {
    marginTop: "0px",
    fontSize: "1em",
    fontWeight: "400",
  },
  printIcon: {
    cursor: "pointer",
    "@media print": {
      display: "none",
    },
  },
};

const PrintIcon = (props) => {
  const { classes, handlePrint } = props;

  return (
    <Tooltip
      title={I18n.get("common_print")}
      placement="bottom"
      classes={{ tooltip: classes.tooltip }}
    >
      <img
        src={images.printIconColored}
        onClick={handlePrint || props.onClick}
        className={classes.printIcon}
        alt="print"
      />
    </Tooltip>
  );
};

export default withStyles(styles)(PrintIcon);
